import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from "clsx";
import { memo } from "react";
import { Stack } from "./Stack";
import { toggleButtonClasses } from "./ToggleButton";
import { ColorsProvider } from "../providers/ColorsProvider";
import { useDefaultProps } from "../providers/utils/defaultProps";
import { mergeSx } from "../system";
export const toggleButtonGroupClasses = {
    root: "MinervaToggleButtonGroup-root",
};
export const toggleButtonGroupSizes = ["small", "large"];
export const ToggleButtonGroup = memo((props) => {
    const { size = "small", value, color = "surface", colorSet, invertColors, className, sx, ...rest } = useDefaultProps({ props, component: "ToggleButtonGroup" });
    const selectedClass = typeof value === "string"
        ? `& .${toggleButtonClasses.selected}-${value}`
        : `& ${value?.map((v) => `.${toggleButtonClasses.selected}-${v}`).join(", ")}`;
    return (_jsx(ColorsProvider, { color: color, colorSet: colorSet, invertColors: invertColors, children: (colorStyles) => (_jsx(Stack, { className: clsx([className, toggleButtonGroupClasses.root]), flexDirection: "row", gap: 0.5, flexWrap: "wrap", sx: mergeSx({
                padding: 1,
                border: 1,
                borderColor: (theme) => theme.palette.stroke[100],
                borderRadius: (theme) => theme.radius.default,
                [`& .${toggleButtonClasses.root}`]: {
                    padding: size === "small" ? 1 : 2,
                    color: colorStyles.background,
                    background: colorStyles.color,
                },
                [selectedClass]: {
                    color: (theme) => theme.palette[color === "inherit" ? "surface" : color]
                        .onContainer,
                    background: (theme) => theme.palette[color === "inherit" ? "surface" : color]
                        .container,
                },
                [`& .${toggleButtonClasses.disabled}`]: {
                    color: (theme) => theme.palette.disabled.onContainer,
                    backgroundColor: (theme) => theme.palette.disabled.container,
                },
            }, sx), ...rest })) }));
});
//# sourceMappingURL=ToggleButtonGroup.js.map